export const CONTACT_SHOW_RESET = 'CONTACT_SHOW_RESET'
export const CONTACT_SHOW_SET_ERROR = 'CONTACT_SHOW_SET_ERROR'
export const CONTACT_SHOW_SET_RETRIEVED = 'CONTACT_SHOW_SET_RETRIEVED'
export const CONTACT_SHOW_TOGGLE_LOADING = 'CONTACT_SHOW_TOGGLE_LOADING'
